import { Link } from "react-router-dom"
import "./Footer.css"

const Footer = ()=>{
     return(
<div className='kiga-footer'>
         <div className="kiga-footer-subscribe">
           <div className="kiga-footer-subscribe-content-text">
            <p>Like our work? Receive our email newsletter</p>
           </div>
           <div className='kiga-footer-subscribe-content-input'>
             <input type='text' placeholder='   your@gmail.com'/>
             <div className='kiga-footer-subscribe-content-subscribe'>
              <p>Subscribe</p>
           </div>
           </div>
         </div>
         <div className='kiga-footer-second-content'>
            <div className='kiga-footer-about'>
              <div className='kiga-footer-about-title'>
                <p>Kigali International<br/><span>Gymnastic Academy</span></p>
              </div>
              <div className='kiga-footer-about-content'>
                 <p>At Kigali International Gymnastics Academy, we believe in the power of discipline, creativity, and perseverance. Founded with a passion for acrobatics and gymnastics arts, our academy is dedicated to training and inspiring the next generation of gymnasts and young athletes. Our specialized Coach is a well known figure in the field of Gymastics with more than 11 years of experience in coaching and training young talents. We provide a structured and supportive environment where students can develop their skills, confidence, and physical strength through Gymnastics and Acrobtics weekly classes. We are currently located at Nyarutarama Sports Center ( 22KG, 13 Avenue. Nyarutarama) well known as Tennis Club.</p>
              </div>
              <div className='kiga-footer-about-social'>

              </div>
            </div>
            <div className='kiga-footer-working'>
              <div className='kiga-footer-about-title'>
                <p>Quick Links</p>
              </div>
              <div className="kiga-footer-working-links">
                <p><Link to='/classes'>- Classes</Link></p>
                <p><Link to='/register'>- Booking</Link></p>
                <p><Link to='/contact'>- contact</Link></p>
                <p><Link to='/login'>- Members</Link></p>
              </div>

            </div>
            <div className='kiga-footer-opening'>
              <div className='kiga-footer-about-title'>
                <p>Opening Hours</p>
              </div>
              <div className="kiga-footer-opening-hours">
                <p>Available</p>
              </div>

            </div>
         </div>
         <div className="kiga-footer-developer">
           <p>All Right Reserved By K.I.G.A</p>
         </div>
       </div>
     )
}

export default Footer